import { z } from 'zod';
import { bindInputMaker } from '../util.make-input.js';
import { selectAnswersMediaInputSchema } from '../select-answers.checkbox/input.media.js';

const makeInput = bindInputMaker();
const radioButtonMediaInput = makeInput({
  entry: {
    schema: z.object({
      type: z.literal("radio-button-media").default("radio-button-media"),
      taskId: z.string().default(""),
      markedAsCorrectAnswer: z.boolean().nullable().default(null)
    }),
    shouldValidate: node => {
      return node.correctAnswer;
    },
    validate: (node, entry) => {
      if (entry.markedAsCorrectAnswer === null) {
        return false;
      }
      return entry.markedAsCorrectAnswer === node.correctAnswer;
    },
    parseLegacyDetailItem: (item, context) => {
      if (context.relatedTask.taskType === "SelectAnswers" && ["RadioButton", "MarkElement"].includes(context.relatedTask.answerType ?? "") && typeof item === "boolean") {
        return [context.relatedInput?.id ?? `${context.relatedTask.id}-${context.indexInDetails}`, {
          type: "radio-button-media",
          taskId: context.relatedTask.id,
          markedAsCorrectAnswer: item
        }];
      }
    }
  },
  schema: selectAnswersMediaInputSchema,
  postprocessSchemaInput: (input, context) => {
    return {
      ...input,
      id: `${context.taskId}-${context.index}`
    };
  }
});

export { radioButtonMediaInput };
//# sourceMappingURL=input.media.js.map
